import api from "./api";
import axios from "axios";

/* ===================================================================
   0. AUTHENTICATION & ACCESS (Sravya's New SRA Flow)
   =================================================================== */

export const registerSuperAdmin = (data) =>
  api.post("/auth-sra/auth/super-admin/register", data);

export const loginSra = (data) =>
  api.post("/auth-sra/auth/login", data);

export const setPasswordSra = (data) =>
  api.post("/auth-sra/auth/set-password", data);


/* ===================================================================
   1. ADMIN – WORKFORCE MANAGEMENT (HR ACTIONS)
   =================================================================== */

export const createEmployee = (data) =>
  api.post("/admin-sra/create-employee", data);

export const getAllEmployeesList = () =>
  api.get("/admin/employees", {
    params: { limit: 1000 } // Fetch up to 1000 employees
  });

export const getAdminEmployeeView = (empCode) =>
  api.get(`/admin/employee/${empCode}/profile`);

export const adminUpdateBasicInfo = (empCode, data) =>
  api.put(`/admin/employee/${empCode}/basic-information`, data);

export const adminUpdateBankStatutory = (empCode, data) =>
  api.put(`/admin/employee/${empCode}/bank-statutory`, data);

export const getTotalEmployeesList = () =>
  api.get("/dashboard/total-employees");

export const getDepartmentStrength = () =>
  api.get("/dashboard/department-strength");


/* ===================================================================
   2. EMPLOYEE – SELF SERVICE & DASHBOARDS
   =================================================================== */

export const getEmployeeDashboard = () =>
  api.get("/employee-sra/employee/dashboard");

export const getManagerDashboard = () =>
  api.get("/employee-sra/employee/manager/dashboard");

export const getAdminDashboard = () =>
  api.get("/employee-sra/employee/admin/dashboard");

export const getEmployeeProfile = () =>
  api.get("/employee/profile");

export const updateSelfBasicInfo = (data) =>
  api.put("/employee/profile/basic-information", data);

export const downloadEmployeeIdCard = (empCode) =>
  api.get(`/employee/employees/${empCode}/id-card`, { responseType: "blob" });

export const getEmployeeHeaderSafe = () => {
  const empCode = localStorage.getItem("emp_code");
  return api.get("/employee/header", {
    params: { emp_code: empCode }
  });
};


/* ===================================================================
   3. ATTENDANCE – FULL END-TO-END (Sravya Attendance SRA)
   =================================================================== */

/* ---------- Punch In / Punch Out ---------- */

export const attendanceCheckIn = () => {
  const emp_code = localStorage.getItem("emp_code");

  if (!emp_code) {
    return Promise.reject("Employee code missing. Please re-login.");
  }

  return api.post(`/attendance/check-in?emp_code=${encodeURIComponent(emp_code)}`);
};

export const attendanceCheckOut = () => {
  const emp_code = localStorage.getItem("emp_code");

  if (!emp_code) {
    return Promise.reject("Employee code missing. Please re-login.");
  }

  return api.post(`/attendance/check-out?emp_code=${encodeURIComponent(emp_code)}`);
};

export const getAttendanceCalendar = ({ year, month }) => {
  const emp_code = localStorage.getItem("emp_code");

  return api.get("/attendance/calendar", {
    params: { emp_code, year, month }
  });
};

export const getAttendanceMonthlySummary = ({ year, month }) => {
  const emp_code = localStorage.getItem("emp_code");
  const month_date = `${year}-${String(month).padStart(2, "0")}-01`;

  return api.get("/attendance/monthly-summary", {
    params: { emp_code, month: month_date }
  });
};

export const getAttendanceRecords = (limit = 30) => {
  const emp_code = localStorage.getItem("emp_code");
  return api.get("/attendance/records", {
    params: { emp_code, limit }
  });
};

export const getTodayAttendance = () => {
  const emp_code = localStorage.getItem("emp_code");
  return api.get("/attendance/today", {
    params: { emp_code }
  });
};

export const getTeamAttendanceRecords = (limit = 100) => {
  const manager_emp_code = localStorage.getItem("emp_code");
  return api.get("/attendance/team/records", {
    params: { manager_emp_code, limit }
  });
};

export const getTeamLeaveRequests = () => {
  const manager_emp_code = localStorage.getItem("emp_code");
  return api.get("/attendance/team/leaves", {
    params: { manager_emp_code }
  });
};


/* ---------- Attendance Corrections ---------- */

export const submitAttendanceCorrection = (data) => {
  const emp_code = localStorage.getItem("emp_code");
  return api.post("/attendance/corrections", data, {
    headers: {
      "x-emp-code": emp_code
    }
  });
};

export const getMyAttendanceCorrections = () => {
  const emp_code = localStorage.getItem("emp_code");
  return api.get("/attendance/corrections/my", {
    headers: {
      "x-emp-code": emp_code
    }
  });
};


/* ===================================================================
   4. LEAVE MANAGEMENT
   =================================================================== */

export const applyLeave = (data) => {
  const emp_code = localStorage.getItem("emp_code");
  return api.post("/leave/request", data, {
    params: { emp_code }
  });
};

export const getMyLeaves = () =>
  api.get("/leave/my");

export const getLeaveBalances = () =>
  api.get("/leave/balances");


/* ===================================================================
   5. TIMESHEET & WORK STATUS  ✅ UPDATED
   =================================================================== */

/**
 * Submit weekly timesheet
 */
export const submitTimesheet = (data, week_start) => {
  const emp_code = localStorage.getItem("emp_code");

  return api.post(
    "/unified_approval/submit_timesheet",
    {
      emp_code,
      week_start,
      timesheet_data: data,
      total_hours: Object.values(data).reduce((sum, day) => sum + (day.hours || 0), 0),
      comments: "Weekly timesheet submitted"
    }
  );
};

/**
 * Request edit for submitted / approved week
 */
export const requestTimesheetEdit = (week_id, body) => {
  const emp_code = localStorage.getItem("emp_code");

  return api.post("/unified_approval/modify_timesheet", {
    emp_code,
    week_id,
    week_start: body.week_start,
    timesheet_data: body.timesheet_data || {},
    total_hours: body.total_hours || 0,
    comments: body.comments || "Timesheet modification request"
  });
};

/**
 * Get my timesheet edit requests
 */
export const getMyTimesheetEditRequests = () => {
  const emp_code = localStorage.getItem("emp_code");

  return api.get("/timesheet/edit-requests/my", {
    params: { emp_code }
  });
};

export const createTimesheetDraft = (weekStart) => {
  const emp_code = localStorage.getItem("emp_code");

  console.log("🔥 createTimesheetDraft emp_code =", emp_code);

  return api.post("/timesheet/draft", null, {
    params: {
      emp_code,
      week_start: weekStart
    }
  });
};

export const getTimesheetWeekId = (weekStart) => {
  const emp_code = localStorage.getItem("emp_code");

  return api.get("/timesheet/week-id", {
    params: { emp_code, week_start: weekStart }
  });
};


/* ===================================================================
   6. DASHBOARD – ATTENDANCE WIDGETS
   =================================================================== */

export const getAttendanceSummary = ({ emp_code, month, year }) => {
  return api.get("/dashboard/attendance-summary", {
    params: { emp_code, month, year }
  });
};

export const getWeeklySummary = ({ emp_code }) => {
  return api.get("/dashboard/weekly-summary", {
    params: { emp_code }
  });
};

export const getMyExceptions = ({ emp_code }) => {
  return api.get("/dashboard/my-exceptions", {
    params: { emp_code }
  });
};


/* ===================================================================
   7. HOLIDAYS & EVENTS
   =================================================================== */

export const getUpcomingHolidays = () =>
  api.get("/holidays/upcoming");

export const getAllHolidays = () =>
  api.get("/holidays/");

export const getWeeklyOffs = () =>
  api.get("/weekly-offs/weekly-offs/");

export const getUpcomingEvents = () =>
  api.get("/courses/dashboard/upcoming-deadlines");


/* ===================================================================
   8. DOCUMENTS & COMPLIANCE
   =================================================================== */

export const getEmployeeDocuments = (empCode) => {
  console.log("\n" + "=".repeat(60));
  console.log("📡 [API] getEmployeeDocuments called");
  console.log("   Employee Code:", empCode);
  console.log("   Endpoint: /employee/documents/admin/employees/" + empCode + "/documents");
  console.log("=".repeat(60));
  
  return api.get(`/employee/documents/admin/employees/${empCode}/documents`)
    .then(response => {
      console.log("✅ [API] getEmployeeDocuments success:", response);
      console.log("=".repeat(60) + "\n");
      return response;
    })
    .catch(error => {
      console.error("\n" + "=".repeat(60));
      console.error("❌ [API] getEmployeeDocuments failed:");
      console.error("   Error:", error);
      console.error("   Error response:", error.response);
      console.error("=".repeat(60) + "\n");
      throw error;
    });
};

export const uploadDocForEmployee = (empCode, formData) => {
  console.log("\n" + "=".repeat(60));
  console.log("📤 [API] uploadDocForEmployee called");
  console.log("   Employee Code:", empCode);
  console.log("   Endpoint: /employee/documents/admin/employees/" + empCode + "/documents");
  console.log("=".repeat(60));
  
  return api.post(`/employee/documents/admin/employees/${empCode}/documents`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  })
    .then(response => {
      console.log("✅ [API] uploadDocForEmployee success:", response);
      console.log("=".repeat(60) + "\n");
      return response;
    })
    .catch(error => {
      console.error("\n" + "=".repeat(60));
      console.error("❌ [API] uploadDocForEmployee failed:");
      console.error("   Error:", error);
      console.error("=".repeat(60) + "\n");
      throw error;
    });
};

export const updateDocumentStatus = (
  empCode,
  docId,
  status,
  rejectionReason = ""
) => {
  console.log("\n" + "=".repeat(60));
  console.log("🔄 [API] updateDocumentStatus called");
  console.log("   Employee Code:", empCode);
  console.log("   Document ID:", docId);
  console.log("   New Status:", status);
  if (rejectionReason) console.log("   Rejection Reason:", rejectionReason);
  console.log("=".repeat(60));
  
  const formData = new FormData();
  formData.append("status", status.toUpperCase());
  if (rejectionReason) {
    formData.append("rejection_reason", rejectionReason);
  }
  
  return api.patch(
    `/employee/documents/admin/employees/${empCode}/documents/${docId}/status`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  )
    .then(response => {
      console.log("✅ [API] updateDocumentStatus success:", response);
      console.log("=".repeat(60) + "\n");
      return response;
    })
    .catch(error => {
      console.error("\n" + "=".repeat(60));
      console.error("❌ [API] updateDocumentStatus failed:");
      console.error("   Error:", error);
      console.error("=".repeat(60) + "\n");
      throw error;
    });
};

export const adminDownloadDoc = (empCode, docId) => {
  console.log("\n" + "=".repeat(60));
  console.log("⬇️ [API] adminDownloadDoc called");
  console.log("   Employee Code:", empCode);
  console.log("   Document ID:", docId);
  console.log("   Endpoint: /employee/documents/admin/employees/" + empCode + "/documents/" + docId + "/download");
  console.log("=".repeat(60));
  
  return api.get(
    `/employee/documents/admin/employees/${empCode}/documents/${docId}/download`
  )
    .then(response => {
      console.log("✅ [API] adminDownloadDoc success:", response);
      console.log("=".repeat(60) + "\n");
      return response;
    })
    .catch(error => {
      console.error("\n" + "=".repeat(60));
      console.error("❌ [API] adminDownloadDoc failed:");
      console.error("   Error:", error);
      console.error("   Error response:", error.response);
      console.error("=".repeat(60) + "\n");
      throw error;
    });
};

export const deleteEmployeeDocument = (empCode, docId) => {
  console.log("\n" + "=".repeat(60));
  console.log("🗑️ [API] deleteEmployeeDocument called");
  console.log("   Employee Code:", empCode);
  console.log("   Document ID:", docId);
  console.log("=".repeat(60));
  
  return api.delete(`/employee/documents/admin/employees/${empCode}/documents/${docId}`)
    .then(response => {
      console.log("✅ [API] deleteEmployeeDocument success:", response);
      console.log("=".repeat(60) + "\n");
      return response;
    })
    .catch(error => {
      console.error("❌ [API] deleteEmployeeDocument failed:", error);
      throw error;
    });
};

export const employeeUploadDocument = (empCode, formData) => {
  console.log("\n" + "=".repeat(60));
  console.log("📤 [API] employeeUploadDocument called");
  console.log("   Employee Code:", empCode);
  console.log("=".repeat(60));
  
  return api.post(`/employee/documents/employee/${empCode}/documents`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  })
    .then(response => {
      console.log("✅ [API] employeeUploadDocument success:", response);
      console.log("=".repeat(60) + "\n");
      return response;
    })
    .catch(error => {
      console.error("❌ [API] employeeUploadDocument failed:", error);
      throw error;
    });
};


/* ===================================================================
   9. CANDIDATE EVALUATION
   =================================================================== */

export const getAllCandidates = () => api.get("/candidates/");
export const createCandidate = (data) => api.post("/candidates/", data);
export const getCandidateDetails = (id) => api.get(`/candidates/${id}`);
export const updateCandidate = (id, data) => api.put(`/candidates/${id}`, data);
export const deleteCandidate = (id) => api.delete(`/candidates/${id}`);

export const uploadCandidateReport = (id, formData) =>
  api.post(`/candidates/${id}/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });


/* ===================================================================
   3B. OVERTIME
   =================================================================== */

export const submitOvertimeRequest = (data) => {
  const emp_code = localStorage.getItem("emp_code");
  return api.post("/overtime", {
    ...data,
    emp_code
  }, {
    headers: {
      "x-emp-code": emp_code
    }
  });
};

export const getMyOvertimeRequests = () => {
  const emp_code = localStorage.getItem("emp_code");
  return api.get("/overtime/my", {
    params: { emp_code }
  });
};

export const getManagerRequests = () => {
  const emp_code = localStorage.getItem("emp_code");
  return api.get("/unified_approval/manager/requests", {
    headers: {
      "x-emp-code": emp_code
    }
  });
};

export const getManagerAttendanceCorrections = () => {
  const emp_code = localStorage.getItem("emp_code");
  return api.get("/manager/attendance-corrections", {
    headers: {
      "x-emp-code": emp_code
    }
  });
};

export const getManagerHistory = (dateFilter = {}) => {
  const emp_code = localStorage.getItem("emp_code");
  const params = {};
  if (dateFilter.from) params.from = dateFilter.from;
  if (dateFilter.to) params.to = dateFilter.to;
  
  return api.get("/unified_approval/manager/requests/history", {
    headers: {
      "x-emp-code": emp_code
    },
    params
  });
};

export const approveManagerRequest = (request_id) => {
  const emp_code = localStorage.getItem("emp_code");
  return api.put(`/unified_approval/manager/requests/${request_id}/approve`, null, {
    headers: {
      "x-emp-code": emp_code
    }
  });
};

export const rejectManagerRequest = (request_id, reason) => {
  const emp_code = localStorage.getItem("emp_code");
  return api.put(
    `/unified_approval/manager/requests/${request_id}/reject`,
    { reason },
    {
      headers: {
        "x-emp-code": emp_code
      }
    }
  );
};


/* ===================================================================
   10. POLICIES
   =================================================================== */

export const getAllPolicies = () => api.get("/policies");

export const acknowledgePolicy = (data) =>
  api.post("/policies/acknowledge", data);

export const getPolicyStats = () =>
  api.get("/dashboard/policy-stats");

export const getManagerPolicyAckStatus = () => {
  const emp_code = localStorage.getItem("emp_code");
  return api.get("/manager/ack-status", {
    headers: {
      "x-emp-code": emp_code
    }
  });
};

export const createPolicy = (data) =>
  api.post("/policies", data);

export const updatePolicy = (id, data) =>
  api.put(`/policies/${id}`, data);

export const deletePolicy = (id) =>
  api.delete(`/policies/${id}`);


/* ===================================================================
   11. REWARDS & INCENTIVES
   =================================================================== */

export const getMyRewards = () =>
  api.get("/rewards/employee/employee/rewards/");

export const getMyRewardInsights = () =>
  api.get("/rewards/employee/employee/rewards/insights");

export const recommendReward = (data) =>
  api.post("/rewards/manager/manager/rewards/recommend", data);

export const getPendingRewardsAdmin = () =>
  api.get("/rewards/admin/admin/rewards/pending");

export const actionRewardAdmin = (recId, data) =>
  api.put(`/rewards/admin/admin/rewards/${recId}/action`, data);

export const getBonusRules = () =>
  api.get("/rules/bonus/bonus-rules/");

export const addBonusRule = (data) =>
  api.post("/rules/bonus/bonus-rules/", data);

export const getIncentiveRules = () =>
  api.get("/rules/incentive/incentive-rules");


/* ===================================================================
   12. LIVE TRACKING SYSTEM
   =================================================================== */

// Live tracking API functions
export const liveTrackingAPI = {
  // Update employee location
  updateLocation: async (empCode, lat, lng) => {
    console.log('📍 Updating location for:', empCode, 'at:', lat, lng);
    try {
      const response = await fetch('/tracking/location/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ emp_code: empCode, lat, lng })
      });
      const result = await response.json();
      console.log('✅ Location update response:', result);
      return result;
    } catch (error) {
      console.error('❌ Location update failed:', error);
      throw error;
    }
  },

  // Notify manager of permission denial
  notifyPermissionDenial: async (empCode, recipientCode, notificationData = {}) => {
    console.log('📧 Notifying recipient of permission denial for:', empCode, 'to:', recipientCode);
    try {
      const response = await fetch('/tracking/permission/denied', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          emp_code: empCode,
          recipient_code: recipientCode,
          timestamp: new Date().toISOString(),
          message: notificationData.message || `Employee ${empCode} has denied location permission`,
          type: notificationData.type || 'location_denied',
          priority: notificationData.priority || 'medium'
        })
      });
      const result = await response.json();
      console.log('✅ Notification sent to', recipientCode, ':', result);
      return result;
    } catch (error) {
      console.error('❌ Notification failed for', recipientCode, ':', error);
      throw error;
    }
  },

  // Get live employees
  getLiveEmployees: async () => {
    try {
      const response = await fetch('/tracking/employees/live-test');
      const result = await response.json();
      console.log('📊 Live employees data:', result);
      return result;
    } catch (error) {
      console.error('❌ Failed to fetch live employees:', error);
      throw error;
    }
  },

  // Get employee live location
  getEmployeeLiveLocation: async (empCode) => {
    try {
      const response = await fetch(`/tracking/employee/${empCode}/live`);
      const result = await response.json();
      console.log('📍 Employee live location:', result);
      return result;
    } catch (error) {
      console.error('❌ Failed to fetch employee location:', error);
      throw error;
    }
  },

  // Get location history for employee
  getLocationHistory: async (empCode, dateFilter = null) => {
    try {
      let url = `/tracking/location/history/${empCode}`;
      if (dateFilter) {
        url += `?date_filter=${dateFilter}`;
      }
      const response = await fetch(url);
      const result = await response.json();
      console.log('📈 Location history:', result);
      return result;
    } catch (error) {
      console.error('❌ Failed to fetch location history:', error);
      throw error;
    }
  },

  // Get employee analytics
  getEmployeeAnalytics: async (empCode, period = '7d') => {
    try {
      const response = await fetch(`/tracking/employee/${empCode}/analytics?period=${period}`);
      const result = await response.json();
      console.log('📊 Employee analytics:', result);
      return result;
    } catch (error) {
      console.error('❌ Failed to fetch employee analytics:', error);
      throw error;
    }
  },

  // Get geofences
  getGeofences: async () => {
    try {
      const response = await fetch('/tracking/geofences');
      const result = await response.json();
      console.log('🗺️ Geofences:', result);
      return result;
    } catch (error) {
      console.error('❌ Failed to fetch geofences:', error);
      throw error;
    }
  },

  // Create geofence
  createGeofence: async (geofenceData) => {
    try {
      const response = await fetch('/tracking/geofences', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(geofenceData)
      });
      const result = await response.json();
      console.log('✅ Geofence created:', result);
      return result;
    } catch (error) {
      console.error('❌ Failed to create geofence:', error);
      throw error;
    }
  },

  // Pause tracking
  pauseTracking: async (empCode, managerCode, description) => {
    try {
      const response = await fetch('/tracking/pause', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          emp_code: empCode,
          manager_code: managerCode,
          description: description,
          timestamp: new Date().toISOString()
        })
      });
      const result = await response.json();
      console.log('✅ Tracking paused:', result);
      return result;
    } catch (error) {
      console.error('❌ Failed to pause tracking:', error);
      throw error;
    }
  },

  // Stop tracking
  stopTracking: async (empCode, managerCode, description) => {
    try {
      const response = await fetch('/tracking/stop', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          emp_code: empCode,
          manager_code: managerCode,
          description: description,
          timestamp: new Date().toISOString()
        })
      });
      const result = await response.json();
      console.log('✅ Tracking stopped:', result);
      return result;
    } catch (error) {
      console.error('❌ Failed to stop tracking:', error);
      throw error;
    }
  },

  // Get pause/stop history
  getPauseStopHistory: async (empCode) => {
    try {
      const response = await fetch(`/tracking/pause-stop-history/${empCode}`);
      const result = await response.json();
      console.log('📋 Pause/stop history:', result);
      return result;
    } catch (error) {
      console.error('❌ Failed to fetch pause/stop history:', error);
      throw error;
    }
  },

  // Get manager pause/stop records
  getManagerPauseStopRecords: async (managerCode) => {
    try {
      const response = await fetch(`/tracking/manager/${managerCode}/pause-stop-records`);
      const result = await response.json();
      console.log('📋 Manager pause/stop records:', result);
      return result;
    } catch (error) {
      console.error('❌ Failed to fetch manager records:', error);
      throw error;
    }
  },

  // Get employee pause/stop summary
  getEmployeePauseStopSummary: async (empCode) => {
    try {
      const response = await fetch(`/tracking/employee/${empCode}/pause-stop-summary`);
      const result = await response.json();
      console.log('📊 Pause/stop summary:', result);
      return result;
    } catch (error) {
      console.error('❌ Failed to fetch pause/stop summary:', error);
      throw error;
    }
  },

  // Get manager team pause/stop stats
  getManagerTeamPauseStopStats: async (managerCode, days = 7) => {
    try {
      const response = await fetch(`/tracking/manager/${managerCode}/team-pause-stop-stats?days=${days}`);
      const result = await response.json();
      console.log('📊 Team pause/stop stats:', result);
      return result;
    } catch (error) {
      console.error('❌ Failed to fetch team stats:', error);
      throw error;
    }
  }
};

/* ===================================================================
   13. UTILITIES & ALIASES
   =================================================================== */

export const getGeneralApi = (url) => api.get(url);
export const updatePersonalDetails = updateSelfBasicInfo;
export const updateOfficialDetails = adminUpdateBasicInfo;
export const updateStatutoryDetails = adminUpdateBankStatutory;


/* ===================================================================
   15. HELP DESK SYSTEM API
   =================================================================== */

export const helpDeskAPI = {
  // ===== TICKET MANAGEMENT =====
  
  // Create new ticket
  createTicket: (ticketData) => {
    const emp_code = localStorage.getItem("emp_code");
    return api.post('/helpdesk/tickets', {
      ...ticketData,
      emp_code
    });
  },
  
  // Get ticket details
  getTicket: (ticketId) => api.get(`/helpdesk/tickets/${ticketId}`),
  
  // Get employee's tickets
  getMyTickets: (status = null, dateFilter = null) => {
    const emp_code = localStorage.getItem("emp_code");
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (dateFilter) params.append('date_filter', dateFilter);
    
    return api.get(`/helpdesk/tickets/employee/${emp_code}?${params.toString()}`);
  },
  
  // Get admin tickets (for admin dashboard)
  getAdminTickets: (filters = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });
    
    return api.get(`/helpdesk/tickets/admin/list?${params.toString()}`);
  },
  
  // Update ticket status
  updateTicketStatus: (ticketId, status, comments = null) => {
    const emp_code = localStorage.getItem("emp_code");
    const user_name = localStorage.getItem("user_name") || "Admin";
    
    return api.put(`/helpdesk/tickets/${ticketId}/status`, {
      ticket_id: ticketId,
      status,
      actor_emp_code: emp_code,
      actor_name: user_name,
      comments
    });
  },
  
  // Assign ticket to agent
  assignTicket: (ticketId, assignedTo, assignedAgentName) => {
    const emp_code = localStorage.getItem("emp_code");
    const user_name = localStorage.getItem("user_name") || "Admin";
    
    return api.put(`/helpdesk/tickets/${ticketId}/assign`, {
      ticket_id: ticketId,
      assigned_to: assignedTo,
      assigned_agent_name: assignedAgentName,
      actor_emp_code: emp_code,
      actor_name: user_name
    });
  },
  
  // ===== MESSAGE MANAGEMENT =====
  
  // Send message in ticket
  sendMessage: (ticketId, content, messageType = "employee", isInternal = false) => {
    const emp_code = localStorage.getItem("emp_code");
    const user_name = localStorage.getItem("user_name") || "User";
    
    return api.post(`/helpdesk/tickets/${ticketId}/messages`, {
      ticket_id: ticketId,
      content,
      message_type: messageType,
      content_type: "text",
      sender_emp_code: emp_code,
      sender_name: user_name,
      is_internal: isInternal
    });
  },
  
  // Get ticket messages
  getTicketMessages: (ticketId, includeInternal = false) => {
    const params = includeInternal ? '?include_internal=true' : '';
    return api.get(`/helpdesk/tickets/${ticketId}/messages${params}`);
  },
  
  // Upload file to ticket
  uploadFile: (ticketId, file, messageType = "employee") => {
    const emp_code = localStorage.getItem("emp_code");
    const user_name = localStorage.getItem("user_name") || "User";
    
    const formData = new FormData();
    formData.append('file', file);
    formData.append('sender_emp_code', emp_code);
    formData.append('sender_name', user_name);
    formData.append('message_type', messageType);
    
    return api.post(`/helpdesk/tickets/${ticketId}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  
  // ===== DASHBOARD & ANALYTICS =====
  
  // Get dashboard statistics
  getDashboardStats: (agentEmpCode = null) => {
    const params = agentEmpCode ? `?agent_emp_code=${agentEmpCode}` : '';
    return api.get(`/helpdesk/dashboard/stats${params}`);
  },
  
  // Get category statistics
  getCategoryStats: () => api.get('/helpdesk/dashboard/categories'),
  
  // Get all agents
  getAllAgents: () => api.get('/helpdesk/agents'),
  
  // Search tickets
  searchTickets: (query, isAdmin = false) => {
    const emp_code = localStorage.getItem("emp_code");
    const params = new URLSearchParams({ q: query });
    
    if (!isAdmin) {
      params.append('emp_code', emp_code);
    } else {
      params.append('is_admin', 'true');
    }
    
    return api.get(`/helpdesk/search?${params.toString()}`);
  },
  
  // Get WebSocket connection stats (admin only)
  getWebSocketStats: () => api.get('/helpdesk/ws/stats')
};


/* ===================================================================
   16. HELP DESK WEBSOCKET CLIENT
   =================================================================== */

class HelpDeskWebSocketClient {
  constructor() {
    this.ws = null;
    this.isConnected = false;
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
    this.reconnectDelay = 1000;
    this.messageHandlers = new Map();
    this.pingInterval = null;
  }
  
  // Connect as employee
  connectAsEmployee(empCode, employeeName) {
    const wsUrl = `wss://hrms.gtplindia.com:8443/helpdesk/ws/employee/${empCode}?employee_name=${encodeURIComponent(employeeName)}`;
    this.connect(wsUrl, 'employee');
  }
  
  // Connect as admin
  connectAsAdmin(adminEmpCode, adminName) {
    const wsUrl = `wss://hrms.gtplindia.com:8443/helpdesk/ws/admin/${adminEmpCode}?admin_name=${encodeURIComponent(adminName)}`;
    this.connect(wsUrl, 'admin');
  }
  
  // Generic connect method
  connect(wsUrl, userType) {
    try {
      this.ws = new WebSocket(wsUrl);
      this.userType = userType;
      
      this.ws.onopen = () => {
        console.log(`✅ Help Desk WebSocket connected as ${userType}`);
        this.isConnected = true;
        this.reconnectAttempts = 0;
        this.startPing();
        
        // Trigger connection event
        this.handleMessage({ type: 'connected', userType });
      };
      
      this.ws.onmessage = (event) => {
        try {
          const message = JSON.parse(event.data);
          this.handleMessage(message);
        } catch (error) {
          console.error('❌ Failed to parse WebSocket message:', error);
        }
      };
      
      this.ws.onclose = () => {
        console.log('🔌 Help Desk WebSocket disconnected');
        this.isConnected = false;
        this.stopPing();
        
        // Attempt reconnection
        if (this.reconnectAttempts < this.maxReconnectAttempts) {
          this.reconnectAttempts++;
          console.log(`🔄 Attempting to reconnect (${this.reconnectAttempts}/${this.maxReconnectAttempts})...`);
          setTimeout(() => this.connect(wsUrl, userType), this.reconnectDelay * this.reconnectAttempts);
        }
      };
      
      this.ws.onerror = (error) => {
        console.error('❌ Help Desk WebSocket error:', error);
      };
      
    } catch (error) {
      console.error('❌ Failed to create WebSocket connection:', error);
    }
  }
  
  // Disconnect
  disconnect() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
    this.isConnected = false;
    this.stopPing();
  }
  
  // Send message
  send(message) {
    if (this.isConnected && this.ws) {
      this.ws.send(JSON.stringify(message));
      return true;
    }
    console.warn('⚠️ WebSocket not connected, message not sent:', message);
    return false;
  }
  
  // Subscribe to ticket updates
  subscribeToTicket(ticketId) {
    this.send({ type: 'subscribe_ticket', ticket_id: ticketId });
  }
  
  // Unsubscribe from ticket updates
  unsubscribeFromTicket(ticketId) {
    this.send({ type: 'unsubscribe_ticket', ticket_id: ticketId });
  }
  
  // Send typing indicator
  sendTyping(ticketId, isTyping) {
    this.send({ type: 'typing', ticket_id: ticketId, is_typing: isTyping });
  }
  
  // Initiate call (admin only)
  initiateCall(ticketId, recipientId, callType = 'voice') {
    if (this.userType === 'admin') {
      this.send({ 
        type: 'initiate_call', 
        ticket_id: ticketId, 
        recipient_id: recipientId, 
        call_type: callType 
      });
    }
  }
  
  // Register message handler
  onMessage(messageType, handler) {
    if (!this.messageHandlers.has(messageType)) {
      this.messageHandlers.set(messageType, []);
    }
    this.messageHandlers.get(messageType).push(handler);
  }
  
  // Remove message handler
  offMessage(messageType, handler) {
    if (this.messageHandlers.has(messageType)) {
      const handlers = this.messageHandlers.get(messageType);
      const index = handlers.indexOf(handler);
      if (index > -1) {
        handlers.splice(index, 1);
      }
    }
  }
  
  // Handle incoming message
  handleMessage(message) {
    const messageType = message.type;
    
    if (this.messageHandlers.has(messageType)) {
      this.messageHandlers.get(messageType).forEach(handler => {
        try {
          handler(message);
        } catch (error) {
          console.error(`❌ Error in message handler for ${messageType}:`, error);
        }
      });
    }
    
    // Handle global message types
    if (this.messageHandlers.has('*')) {
      this.messageHandlers.get('*').forEach(handler => {
        try {
          handler(message);
        } catch (error) {
          console.error('❌ Error in global message handler:', error);
        }
      });
    }
  }
  
  // Start ping to keep connection alive
  startPing() {
    this.pingInterval = setInterval(() => {
      if (this.isConnected) {
        this.send({ type: 'ping' });
      }
    }, 30000); // Ping every 30 seconds
  }
  
  // Stop ping
  stopPing() {
    if (this.pingInterval) {
      clearInterval(this.pingInterval);
      this.pingInterval = null;
    }
  }
  
  // Get connection status
  getStatus() {
    return {
      isConnected: this.isConnected,
      userType: this.userType,
      reconnectAttempts: this.reconnectAttempts
    };
  }
}

// Export singleton instance
export const helpDeskWebSocket = new HelpDeskWebSocketClient();

// Convenience functions for common operations
export const helpDeskUtils = {
  // Initialize WebSocket connection
  initializeWebSocket: (userType = 'employee') => {
    const empCode = localStorage.getItem('emp_code');
    const userName = localStorage.getItem('user_name') || 'User';
    
    if (!empCode) {
      console.error('❌ No employee code found, cannot connect to WebSocket');
      return false;
    }
    
    if (userType === 'admin') {
      helpDeskWebSocket.connectAsAdmin(empCode, userName);
    } else {
      helpDeskWebSocket.connectAsEmployee(empCode, userName);
    }
    
    return true;
  },
  
  // Format ticket priority for display
  formatPriority: (priority) => {
    const priorityColors = {
      'Low': 'text-green-600 bg-green-100',
      'Medium': 'text-yellow-600 bg-yellow-100',
      'High': 'text-orange-600 bg-orange-100',
      'Critical': 'text-red-600 bg-red-100'
    };
    return priorityColors[priority] || 'text-gray-600 bg-gray-100';
  },
  
  // Format ticket status for display
  formatStatus: (status) => {
    const statusColors = {
      'Open': 'text-blue-600 bg-blue-100',
      'Pending': 'text-yellow-600 bg-yellow-100',
      'In Progress': 'text-purple-600 bg-purple-100',
      'Resolved': 'text-green-600 bg-green-100',
      'Closed': 'text-gray-600 bg-gray-100'
    };
    return statusColors[status] || 'text-gray-600 bg-gray-100';
  },
  
  // Format file size
  formatFileSize: (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  },
  
  // Get time ago string
  getTimeAgo: (dateString) => {
    const now = new Date();
    const date = new Date(dateString);
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    if (diffInSeconds < 60) return 'Just now';
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} mins ago`;
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} hours ago`;
    return `${Math.floor(diffInSeconds / 86400)} days ago`;
  },
  
  // Validate ticket data
  validateTicketData: (ticketData) => {
    const errors = [];
    
    if (!ticketData.subject || ticketData.subject.trim().length < 5) {
      errors.push('Subject must be at least 5 characters long');
    }
    
    if (!ticketData.description || ticketData.description.trim().length < 10) {
      errors.push('Description must be at least 10 characters long');
    }
    
    if (!ticketData.category) {
      errors.push('Category is required');
    }
    
    return errors;
  }
};

// Help Desk shortcuts for backward compatibility
export const createHelpDeskTicket = helpDeskAPI.createTicket;
export const getMyHelpDeskTickets = helpDeskAPI.getMyTickets;
export const sendHelpDeskMessage = helpDeskAPI.sendMessage;
export const getHelpDeskDashboard = helpDeskAPI.getDashboardStats;


/* ===================================================================
   13. HOLIDAYS & WEEKLY OFFS
   =================================================================== */

export const holidayAPI = {
  // Holidays
  listHolidays: () => api.get('/holidays/'),
  addHoliday: (data) => api.post('/holidays/', data),
  editHoliday: (holidayId, data) => api.put(`/holidays/${holidayId}`, data),
  deleteHoliday: (holidayId) => api.delete(`/holidays/${holidayId}`),
  getUpcomingHolidays: () => api.get('/holidays/upcoming'),
  getSingleHolidayIcs: (holidayId) => api.get(`/holidays/${holidayId}/ics`),
  exportAllHolidaysIcs: () => api.get('/holidays/ics'),
  
  // Weekly Offs
  getWeeklyOffs: () => api.get('/weekly-offs/weekly-offs/'),
  updateWeeklyOff: (data) => api.post('/weekly-offs/weekly-offs/', data),
  updateBulkWeeklyOffs: (data) => api.post('/weekly-offs/weekly-offs/bulk', data)
};


/* ===================================================================
   14. BONUS & INCENTIVE RULES API
   =================================================================== */

export const rulesAPI = {
  // Bonus Rules
  getBonusRules: () => api.get('/rules/bonus/bonus-rules/'),
  addBonusRule: (data) => api.post('/rules/bonus/bonus-rules/', data),
  editBonusRule: (ruleId, data) => api.put(`/rules/bonus/bonus-rules/${ruleId}`, data),
  deleteBonusRule: (ruleId) => api.delete(`/rules/bonus/bonus-rules/${ruleId}`),
  
  // Incentive Rules
  getIncentiveRules: () => api.get('/rules/incentive/incentive-rules'),
  addIncentiveRule: (data) => api.post('/rules/incentive/incentive-rules/incentive-rules', data),
  deleteIncentiveRule: (ruleId) => api.delete(`/rules/incentive/incentive-rules/${ruleId}`),
  
  // Manager Bonus Rules
  getManagerBonusRules: () => api.get('/rules/manager-rules/manager/rules/bonus'),
  addManagerBonusRule: (data) => api.post('/rules/manager-rules/manager/rules/bonus', data),
  
  // Manager Incentive Rules
  getManagerIncentiveRules: () => api.get('/rules/manager-rules/manager/rules/incentive'),
  addManagerIncentiveRule: (data) => api.post('/rules/manager-rules/manager/rules/incentive', data)
};

/* ===================================================================
   15. EMPLOYEE OFFBOARDING API (ADMIN)
   =================================================================== */

export const adminOffboardingAPI = {
  // Phase 1: Employee Lookup
  lookupEmployee: (employeeId) => {
    return api.get(`/admin/offboarding/employee/${employeeId}`);
  },

  // Phase 1: Initiate Offboarding
  initiateOffboarding: (data) => {
    return api.post('/admin/offboarding/initiate', data);
  },

  // Phase 2: Calculate Last Working Day
  calculateLWD: (offboardingId, data) => {
    return api.put(`/admin/offboarding/${offboardingId}/calculate-lwd`, data);
  },

  // Phase 3: Get Phase 3 Data
  getPhase3Data: (offboardingId) => {
    return api.get(`/admin/offboarding/${offboardingId}/phase3`);
  },

  // Phase 3: Update Asset Status
  updateAsset: (assetId, data) => {
    return api.put(`/admin/offboarding/phase3/asset/${assetId}`, data);
  },

  // Phase 3: Update Clearance Status
  updateClearance: (clearanceId, data) => {
    return api.put(`/admin/offboarding/phase3/clearance/${clearanceId}`, data);
  },

  // Phase 3: Complete Phase 3
  completePhase3: (offboardingId) => {
    return api.post(`/admin/offboarding/${offboardingId}/complete-phase3`);
  },

  // Phase 4: Update Declaration
  updateDeclaration: (offboardingId, data) => {
    return api.put(`/admin/offboarding/phase4/declaration/${offboardingId}`, data);
  },

  // Phase 4: Download Clearance PDF
  downloadClearancePDF: (offboardingId) => {
    return api.get(`/admin/offboarding/phase4/${offboardingId}/clearance-pdf`, {
      responseType: 'blob'
    });
  },

  // Phase 4: Complete Phase 4
  completePhase4: (offboardingId) => {
    return api.post(`/admin/offboarding/phase4/${offboardingId}/complete`);
  },

  // Phase 5: Finalize Offboarding
  finalizeOffboarding: (offboardingId, data) => {
    return api.post(`/admin/offboarding/phase5/${offboardingId}/finalize`, data);
  }
};

// Convenience exports for admin offboarding
export const lookupEmployee = adminOffboardingAPI.lookupEmployee;
export const initiateOffboarding = adminOffboardingAPI.initiateOffboarding;
export const calculateLWD = adminOffboardingAPI.calculateLWD;
export const getPhase3Data = adminOffboardingAPI.getPhase3Data;
export const updateAssetStatus = adminOffboardingAPI.updateAsset;
export const updateClearanceStatus = adminOffboardingAPI.updateClearance;
export const completePhase3 = adminOffboardingAPI.completePhase3;
export const updateOffboardingDeclaration = adminOffboardingAPI.updateDeclaration;
export const downloadClearancePDF = adminOffboardingAPI.downloadClearancePDF;
export const completePhase4 = adminOffboardingAPI.completePhase4;
export const finalizeOffboarding = adminOffboardingAPI.finalizeOffboarding;

/* ===================================================================
   15. EMPLOYEE OFFBOARDING API
   =================================================================== */

export const offboardingAPI = {
  // Get current offboarding status
  getOffboardingStatus: () => {
    const emp_code = localStorage.getItem("emp_code");
    return api.get("/offboarding/", {
      headers: { "emp-code": emp_code }
    });
  },

  // Submit resignation
  submitResignation: (resignationData) => {
    const emp_code = localStorage.getItem("emp_code");
    return api.post("/offboarding/submit-resignation", resignationData, {
      headers: { "emp-code": emp_code }
    });
  },

  // Submit handover documentation
  submitHandover: (handoverData) => {
    const emp_code = localStorage.getItem("emp_code");
    return api.post("/offboarding/handover", handoverData, {
      headers: { "emp-code": emp_code }
    });
  },

  // Confirm asset return
  confirmAssetReturn: (assetData) => {
    const emp_code = localStorage.getItem("emp_code");
    return api.post("/offboarding/assets/confirm", assetData, {
      headers: { "emp-code": emp_code }
    });
  },

  // Submit final documentation
  submitFinalDocs: (docsData) => {
    const emp_code = localStorage.getItem("emp_code");
    return api.post("/offboarding/final-submission", docsData, {
      headers: { "emp-code": emp_code }
    });
  },

  // Manager: Get pending approvals
  getPendingApprovals: () => {
    const emp_code = localStorage.getItem("emp_code");
    return api.get("/offboarding/manager/pending", {
      headers: { "emp-code": emp_code }
    });
  },

  // Manager: Approve/reject resignation
  approveResignation: (resignationId, decision) => {
    const emp_code = localStorage.getItem("emp_code");
    return api.post(`/offboarding/manager/approve/${resignationId}`, decision, {
      headers: { "emp-code": emp_code }
    });
  },

  // HR: Get pending approvals
  getHRPendingApprovals: () => {
    const emp_code = localStorage.getItem("emp_code");
    return api.get("/offboarding/hr/pending", {
      headers: { "emp-code": emp_code }
    });
  },

  // HR: Approve/reject resignation
  hrApproveResignation: (resignationId, decision) => {
    const emp_code = localStorage.getItem("emp_code");
    return api.post(`/offboarding/hr/approve/${resignationId}`, decision, {
      headers: { "emp-code": emp_code }
    });
  }
};

// Convenience exports for offboarding
export const getOffboardingStatus = offboardingAPI.getOffboardingStatus;
export const submitResignation = offboardingAPI.submitResignation;
export const submitHandover = offboardingAPI.submitHandover;
export const confirmAssetReturn = offboardingAPI.confirmAssetReturn;
export const submitFinalDocs = offboardingAPI.submitFinalDocs;

/* ===================================================================
   SHIFT MANAGEMENT & ROTATION API
   =================================================================== */

export const shiftAPI = {
  // Shift Master Management
  createShift: (data) => api.post('/admin/shifts', null, { params: data }),
  listShifts: () => api.get('/admin/shifts'),
  updateShift: (shiftId, data) => api.put(`/admin/shifts/${shiftId}`, null, { params: data }),
  
  // Employee List
  listEmployees: () => api.get('/admin/shifts/employees'),
  
  // Shift Assignment
  assignShift: (data) => api.post('/admin/shifts/assign', null, { params: data }),
  bulkAssignShift: (data) => api.post('/admin/shifts/assign/bulk', data),
  
  // Get My Shift (Employee)
  getMyShift: () => {
    const emp_code = localStorage.getItem("emp_code");
    return api.get('/shift/my', { params: { emp_code } });
  },
  
  // Rotation Management
  createRotation: (data) => api.post('/admin/shifts/rotations', null, { params: data }),
  listRotations: () => api.get('/admin/shifts/rotations'),
  addRotationShifts: (rotationId, shifts) => api.post(`/admin/shifts/rotations/${rotationId}/shifts`, shifts),
  
  // Reports
  getDailyReport: (day) => api.get('/admin/shifts/reports/daily', { params: { day } }),
  getWeeklyReport: (weekStart) => api.get('/admin/shifts/reports/weekly', { params: { week_start: weekStart } }),
  getMonthlyReport: (year, month) => api.get('/admin/shifts/reports/monthly', { params: { year, month } }),
  getQuarterlyReport: (year, quarter) => api.get('/admin/shifts/reports/quarterly', { params: { year, quarter } }),
  getHalfYearlyReport: (year, half) => api.get('/admin/shifts/reports/half-yearly', { params: { year, half } }),
  getYearlyReport: (year) => api.get('/admin/shifts/reports/yearly', { params: { year } }),
  getCustomReport: (startDate, endDate) => api.get('/admin/shifts/reports/custom', { params: { start_date: startDate, end_date: endDate } }),
  
  // Export Reports
  exportReport: (startDate, endDate, format = 'csv') => {
    return api.get('/admin/shifts/reports/export', {
      params: { start_date: startDate, end_date: endDate, format },
      responseType: 'blob'
    });
  }
};

// Convenience exports for shift management
export const createShift = shiftAPI.createShift;
export const listShifts = shiftAPI.listShifts;
export const assignShift = shiftAPI.assignShift;
export const bulkAssignShift = shiftAPI.bulkAssignShift;
export const getMyShift = shiftAPI.getMyShift;
export const createRotation = shiftAPI.createRotation;
export const listRotations = shiftAPI.listRotations;

/* ===================================================================
   ASSET MANAGEMENT (INVENTORY) API
   =================================================================== */

export const assetAPI = {
  // Get next asset ID
  getNextAssetId: () => {
    console.log('📋 Fetching next asset ID');
    return api.get('/assets/next-id');
  },

  // List all assets
  listAssets: () => {
    console.log('📋 Fetching all assets');
    return api.get('/assets/');
  },

  // Get total assets count
  getTotalAssets: () => {
    console.log('📊 Fetching total assets count');
    return api.get('/assets/count');
  },

  // Create new asset
  createAsset: (assetData, invoiceFile = null) => {
    console.log('➕ Creating new asset:', assetData);
    const formData = new FormData();
    
    // Append all asset data
    Object.keys(assetData).forEach(key => {
      if (assetData[key] !== null && assetData[key] !== undefined) {
        formData.append(key, assetData[key]);
      }
    });
    
    // Append invoice file if provided
    if (invoiceFile) {
      formData.append('invoice_file', invoiceFile);
    }
    
    return api.post('/assets/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  // Get asset by code
  getAsset: (assetCode) => {
    console.log('🔍 Fetching asset:', assetCode);
    return api.get(`/assets/${assetCode}`);
  },

  // Update asset
  updateAsset: (assetCode, assetData, invoiceFile = null) => {
    console.log('✏️ Updating asset:', assetCode);
    const formData = new FormData();
    
    // Append all asset data
    Object.keys(assetData).forEach(key => {
      if (assetData[key] !== null && assetData[key] !== undefined) {
        formData.append(key, assetData[key]);
      }
    });
    
    // Append invoice file if provided
    if (invoiceFile) {
      formData.append('invoice_file', invoiceFile);
    }
    
    return api.put(`/assets/${assetCode}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  // Delete asset
  deleteAsset: (assetCode) => {
    console.log('🗑️ Deleting asset:', assetCode);
    return api.delete(`/assets/${assetCode}`);
  },

  // Get asset reports with filters
  getAssetReports: (filters = {}) => {
    console.log('📊 Generating asset report with filters:', filters);
    const params = new URLSearchParams();
    
    if (filters.search) params.append('search', filters.search);
    if (filters.filter) params.append('filter', filters.filter);
    if (filters.from_date) params.append('from_date', filters.from_date);
    if (filters.to_date) params.append('to_date', filters.to_date);
    
    return api.get(`/assets/reports?${params.toString()}`);
  },

  // View invoice
  viewInvoice: (assetCode) => {
    console.log('📄 Viewing invoice for asset:', assetCode);
    return api.get(`/assets/${assetCode}/invoice`);
  },

  // Download invoice
  downloadInvoice: (assetCode) => {
    console.log('⬇️ Downloading invoice for asset:', assetCode);
    return api.get(`/assets/${assetCode}/invoice/download`);
  }
};

// Convenience exports for asset management
export const getNextAssetId = assetAPI.getNextAssetId;
export const listAssets = assetAPI.listAssets;
export const getTotalAssets = assetAPI.getTotalAssets;
export const createAsset = assetAPI.createAsset;
export const getAsset = assetAPI.getAsset;
export const updateAsset = assetAPI.updateAsset;
export const deleteAsset = assetAPI.deleteAsset;
export const getAssetReports = assetAPI.getAssetReports;
export const viewInvoice = assetAPI.viewInvoice;
export const downloadInvoice = assetAPI.downloadInvoice;

/* ===================================================================
   PAYROLL MANAGEMENT API
   =================================================================== */

export const payrollAPI = {
  // Select tax regime
  selectTaxRegime: (data) => {
    return api.post('/payroll-bulk/select-tax-regime', data);
  },

  // Generate individual payslip
  generatePayslip: (data) => {
    return api.post('/payroll-bulk/generate', data);
  },

  // Generate bulk payslips
  generateBulkPayslips: (data) => {
    return api.post('/payroll-bulk/generate-bulk', data);
  },

  // Request payslip
  requestPayslip: (data) => {
    return api.post('/payroll-bulk/request', data);
  },

  // Approve payslip request
  approvePayslipRequest: (data) => {
    return api.post('/payroll-bulk/approve', data);
  },

  // Reject payslip request
  rejectPayslipRequest: (data) => {
    console.log('API: Rejecting payslip request with data:', data);
    return api.post('/payroll-bulk/reject', data);
  },

  // Generate Form 16 Part B
  generateForm16PartB: (data) => {
    return api.post('/payroll-bulk/form16/part-b', data);
  },

  // Get payslip requests (admin)
  getPayslipRequests: () => {
    return api.get('/payroll-bulk/requests');
  },

  // Get my payslip requests (employee)
  getMyPayslipRequests: () => {
    return api.get('/payroll-bulk/my-requests');
  },

  // Download payslip
  downloadPayslip: (data) => {
    return api.post('/payroll-bulk/download', data);
  },

  // Get generated payslips (for reports)
  getGeneratedPayslips: () => {
    return api.get('/payroll-bulk/generated-payslips');
  }
};

// Employee payslip APIs for Pay.jsx
export const employeePayslipAPI = {
  // Get my payslips
  getMyPayslips: () => {
    const emp_code = localStorage.getItem("emp_code");
    return api.get('/payroll-bulk/employee/payslips', {
      params: { emp_code }
    });
  },

  // Get payslip details for specific month
  getPayslipDetails: (month, year) => {
    const emp_code = localStorage.getItem("emp_code");
    return api.get('/payroll-bulk/employee/payslip-details', {
      params: { emp_code, month, year }
    });
  },

  // Get payslip history for dashboard
  getPayslipHistory: (months = 6) => {
    const emp_code = localStorage.getItem("emp_code");
    return api.get('/payroll-bulk/employee/history', {
      params: { emp_code, months }
    });
  },

  // Download payslip PDF
  downloadPayslipPDF: (month, year) => {
    const emp_code = localStorage.getItem("emp_code");
    console.log(`Downloading payslip PDF for ${emp_code} - ${month} ${year}`);
    return api.post('/payroll-bulk/download', {
      emp_code,
      month,
      year
    }).then(response => {
      console.log('Raw API response in downloadPayslipPDF:', response);
      return { data: response }; // Wrap response to match expected structure
    }).catch(error => {
      console.error('Error in downloadPayslipPDF:', error);
      throw error;
    });
  },

  // Request payslip
  requestPayslip: (month, year) => {
    const emp_code = localStorage.getItem("emp_code");
    console.log(`Requesting payslip for ${emp_code} - ${month} ${year}`);
    return api.post('/payroll-bulk/request', {
      emp_code,
      month,
      year
    });
  },

  // Get my payslip requests
  getMyPayslipRequests: () => {
    const emp_code = localStorage.getItem("emp_code");
    return api.get('/payroll-bulk/my-requests', {
      params: { emp_code }
    });
  }
};

// Notifications API
export const notificationsAPI = {
  getNotifications: (limit = 10) => {
    const emp_code = localStorage.getItem("emp_code");
    return api.get('/api/notifications', {
      params: { emp_code, limit }
    });
  },
  markAsRead: (notificationId) => {
    const emp_code = localStorage.getItem("emp_code");
    return api.post(`/api/notifications/${notificationId}/mark-read`, null, {
      params: { emp_code }
    });
  },
  markAllAsRead: () => {
    const emp_code = localStorage.getItem("emp_code");
    return api.post('/api/notifications/mark-all-read', null, {
      params: { emp_code }
    });
  }
};

// Additional payroll API for missing endpoint
export const getGeneratedPayslips = () => {
  return api.get('/payroll-bulk/generated-payslips');
};

/* ===================================================================
   BIOMETRIC INTEGRATION API
   =================================================================== */

export const biometricAPI = {
  // Biometric Devices
  listDevices: () => api.get('/biometric/biometric-devices/'),
  createDevice: (data) => api.post('/biometric/biometric-devices/', data),
  updateDevice: (deviceId, data) => api.put(`/biometric/biometric-devices/${deviceId}`, data),
  deleteDevice: (deviceId) => api.delete(`/biometric/biometric-devices/${deviceId}`),
  
  // Device Assignments
  listAssignments: () => api.get('/assignment/device-assignments/'),
  createAssignment: (data) => api.post('/assignment/device-assignments/', data),
  updateAssignment: (assignmentId, data) => api.put(`/assignment/device-assignments/${assignmentId}`, data),
  deleteAssignment: (assignmentId) => api.delete(`/assignment/device-assignments/${assignmentId}`)
};

/* ===================================================================
   APPRAISAL SYSTEM API
   =================================================================== */

export const appraisalAPI = {
  // Admin: Create Appraisal Cycle
  createAppraisalCycle: (year) => {
    console.log('📋 Creating appraisal cycle for year:', year);
    return api.post('/api/admin/appraisal-cycles', { year });
  },

  // Manager: Assign KPIs to Employees
  assignKPIs: (data) => {
    const manager_emp_code = localStorage.getItem("emp_code");
    console.log('📝 Assigning KPIs:', data);
    return api.post('/api/manager/assign-kpis', {
      ...data,
      manager_emp_code
    });
  },

  // Employee: View Assigned Goals
  getEmployeeGoals: (cycleId) => {
    const emp_code = localStorage.getItem("emp_code");
    console.log(`🎯 Fetching goals for ${emp_code}, cycle ${cycleId}`);
    return api.get(`/api/employee/goals/${emp_code}/${cycleId}`);
  },

  // Employee: Submit Self Review
  submitSelfReview: (cycleId, reviews) => {
    const emp_code = localStorage.getItem("emp_code");
    console.log(`✍️ Submitting self review for cycle ${cycleId}`);
    return api.post(`/api/employee/submit-review/${cycleId}?emp_code=${emp_code}`, reviews);
  },

  // Manager: View Employee Submission
  getEmployeeReview: (empCode, cycleId) => {
    console.log(`👀 Viewing employee ${empCode} review for cycle ${cycleId}`);
    return api.get(`/api/manager/employee-review/${empCode}/${cycleId}`);
  },

  // Manager: Submit Manager Review
  submitManagerReview: (cycleId, reviews) => {
    console.log(`✅ Submitting manager review for cycle ${cycleId}`);
    return api.post(`/api/manager/submit-review/${cycleId}`, reviews);
  },

  // Manager: Propose Compensation
  proposeCompensation: (data) => {
    console.log('💰 Proposing compensation:', data);
    return api.post('/api/manager/compensation-proposal', data);
  },

  // Admin: Approve Compensation
  approveCompensation: (data) => {
    const approved_by = localStorage.getItem("emp_code");
    console.log('✅ Approving compensation:', data);
    return api.post('/api/admin/approve-compensation', {
      ...data,
      approved_by
    });
  },

  // Admin: Reject Appraisal
  rejectAppraisal: (data) => {
    const rejected_by = localStorage.getItem("emp_code");
    console.log('❌ Rejecting appraisal:', data);
    return api.post('/api/admin/reject-appraisal', {
      ...data,
      rejected_by
    });
  },

  // Employee: View Final Appraisal
  getFinalAppraisal: (cycleId) => {
    const emp_code = localStorage.getItem("emp_code");
    console.log(`🏆 Fetching final appraisal for ${emp_code}, cycle ${cycleId}`);
    return api.get(`/api/employee/final-appraisal/${emp_code}/${cycleId}`);
  },

  // Admin: Get Appraisal Report
  getAdminReport: (cycleId) => {
    console.log(`📊 Fetching admin report for cycle ${cycleId}`);
    return api.get(`/api/admin/appraisal-report/${cycleId}`);
  },

  // Admin: Get Manager-wise Report
  getManagerReport: (cycleId) => {
    console.log(`📊 Fetching manager-wise report for cycle ${cycleId}`);
    return api.get(`/api/admin/appraisal-report-per-manager/${cycleId}`);
  },

  // Super Admin: Get Manager Appraisal Report
  getSuperAdminReport: (cycleId) => {
    console.log(`📊 Fetching super admin report for cycle ${cycleId}`);
    return api.get(`/api/super-admin/manager-appraisal-report/${cycleId}`);
  },

  // Employee: Get Appraisal Activity Logs
  getEmployeeLogs: () => {
    const emp_code = localStorage.getItem("emp_code");
    console.log(`📜 Fetching appraisal logs for ${emp_code}`);
    return api.get(`/api/employee/appraisal-logs/${emp_code}`);
  },

  // Manager: Get Appraisal Activity Logs
  getManagerLogs: () => {
    const manager_emp_code = localStorage.getItem("emp_code");
    console.log(`📜 Fetching appraisal logs for manager ${manager_emp_code}`);
    return api.get(`/api/manager/appraisal-logs/${manager_emp_code}`);
  },

  // Admin: Get All Appraisal Activity Logs
  getAdminLogs: () => {
    console.log('📜 Fetching all appraisal logs');
    return api.get('/api/admin/appraisal-logs');
  }
};

// Convenience exports for appraisal system
export const createAppraisalCycle = appraisalAPI.createAppraisalCycle;
export const assignKPIs = appraisalAPI.assignKPIs;
export const getEmployeeGoals = appraisalAPI.getEmployeeGoals;
export const submitSelfReview = appraisalAPI.submitSelfReview;
export const getEmployeeReview = appraisalAPI.getEmployeeReview;
export const submitManagerReview = appraisalAPI.submitManagerReview;
export const proposeCompensation = appraisalAPI.proposeCompensation;
export const approveCompensation = appraisalAPI.approveCompensation;
export const rejectAppraisal = appraisalAPI.rejectAppraisal;
export const getFinalAppraisal = appraisalAPI.getFinalAppraisal;
export const getAdminAppraisalReport = appraisalAPI.getAdminReport;
export const getManagerAppraisalReport = appraisalAPI.getManagerReport;
export const getSuperAdminAppraisalReport = appraisalAPI.getSuperAdminReport;
export const getEmployeeAppraisalLogs = appraisalAPI.getEmployeeLogs;
export const getManagerAppraisalLogs = appraisalAPI.getManagerLogs;
export const getAdminAppraisalLogs = appraisalAPI.getAdminLogs;